

import * as axios from "axios"
import * as uniqBy from "lodash/uniqBy"
import { ArticleCommentData, ArticleCommentsStorageState, SortingOptions } from "../../article/componentas/articleComments/interfaces"
import { SiteWebStorage } from "../../../widgetsUtils"
import { addAxiosDateTransformerSettings } from "../../../../utils/network/axiosDateTransformer"
import { AddCommentFormRenderProps, AddCommentFormWrapper, AddCommentFormRender } from "../../article/componentas/articleComments/addCommentFormWrapper"
import { ArticleCommentsTopTabRenderProps, ArticleCommentsTopTabRender } from "../../article/componentas/articleComments/articleCommentsTopTabWrapper"
import { ArticleCommentRenderProps, ArticleCommentWrapper, ArticleCommentRender } from "../../article/componentas/articleComments/articleCommentWrapper"
import { getTranslation } from "../../article/componentas/articleComments/translations"
import { AddCommentFormUIGalhed } from "./addCommentFormGalhed"
import { ArticleCommentGalhedUi } from "./articleCommentUI"
import { MobileAddCommentFormUIGalhed } from "./mobileFormPopUp"



interface SiteArticleCommentsProps {
    articleId: string
    lang: string
    showFormWhenEmpty?: boolean
    displayType?: "desktop" | "mobile";
    title: string
    profileImageSrc: string
    roof: string
    isNewDesign?: boolean
}

interface SiteArticleCommentsState {
    comments: ArticleCommentData[]
    numOfDiscussions: number
    numOfComments: number
    areAllCommentsExpanded: boolean
    sortSelection: SortingOptions
    IdOfLastTalkbackExpandedByUser: number
    page: number
    hasMore: boolean
    isAllCommentsPopupVisable: boolean
    isPopupOpen: boolean
    bodyOverflowState: string


}


export class GalhedSiteArticleComments extends React.Component<SiteArticleCommentsProps, SiteArticleCommentsState> {
    public static siteScriptName = "GalhedSiteArticleComments";
    public isWcmCommetnsRecived = false;
    constructor(props) {

        super(props)
        this.state = {
            comments: [],
            numOfDiscussions: 0,
            numOfComments: 0,
            areAllCommentsExpanded: false,
            sortSelection: "end_to_start",
            IdOfLastTalkbackExpandedByUser: null,
            page: 1,
            hasMore: false,
            isAllCommentsPopupVisable: false,
            isPopupOpen: false,
            bodyOverflowState: "",
        }
    }

    componentDidMount() {
        const { articleId, showFormWhenEmpty } = this.props
        const articleCommentsState: ArticleCommentsStorageState = SiteWebStorage.getSessionStorageItem("articleCommentsState");
        if (articleCommentsState && (articleCommentsState.articleId === articleId)) {
            this.setState({
                areAllCommentsExpanded: articleCommentsState.areAllCommentsExpanded,
                sortSelection: articleCommentsState.sortSelection,
                IdOfLastTalkbackExpandedByUser: articleCommentsState.IdOfLastTalkbackExpandedByUser,
                page: 1,
            })
            this.getCommentsData(articleCommentsState.sortSelection);
        }
        else {
            this.getCommentsData("end_to_start");
        }



        // Set initial max-height
        if (this.props.displayType === "desktop") {
            this.adjustCommentsMaxHeight();
            setTimeout(() => {
                this.adjustCommentsMaxHeight();
            }, 100);
        }


        // Adjust on window resize
        if (this.props.displayType === "desktop") {
            window.addEventListener('resize', this.adjustCommentsMaxHeight);
        }
    }

    componentWillUnmount() {
        if (typeof window !== "undefined") {
            window.removeEventListener('resize', this.adjustCommentsMaxHeight);
        }
    }

    private adjustCommentsMaxHeight = () => {
        const commentsDiv = document.querySelector('.GalhedSiteArticleComments') as HTMLElement;
        const articleBodyDiv = document.getElementById('ArticleBodyComponent');

        if (commentsDiv && articleBodyDiv) {
            const articleBodyHeight = articleBodyDiv.offsetHeight;
            commentsDiv.style.maxHeight = `${articleBodyHeight}px`;
            commentsDiv.style.overflowY = 'auto';
        }
    }

    private getTalkbackNumberView = (tbNumber: number) => {
        const stringNumber = tbNumber.toString()
        let number = stringNumber

        if (stringNumber.length > 3) {
            number = stringNumber.charAt(0) + "k"
        } else if (stringNumber.length > 4) {
            number = stringNumber.charAt(0) + stringNumber.charAt(1) + "k"
        } else if (parseInt(stringNumber) === 0) {
            number = "";
        }

        return number
    }

    private updateArticleCommentsStorageState = (talkbackId = null, allCommentsExpanded?) => {
        const { articleId } = this.props
        const { areAllCommentsExpanded, sortSelection, IdOfLastTalkbackExpandedByUser } = this.state
        const plainArticleCommentsState: ArticleCommentsStorageState = {
            articleId,
            areAllCommentsExpanded: allCommentsExpanded || areAllCommentsExpanded,
            IdOfLastTalkbackExpandedByUser: talkbackId || IdOfLastTalkbackExpandedByUser,
            sortSelection,
        }
        SiteWebStorage.setSessionStorageItem("articleCommentsState", plainArticleCommentsState)
    }

    private getCommentsData = (sortBy: SortingOptions = "end_to_start", page: number = 1) => {
        const { articleId, showFormWhenEmpty } = this.props
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());


        const pageNumber = page;
        const api = `/iphone/json/api/talkbacks/list/v2/${articleId}/${sortBy}/${pageNumber}`;
        axiosInstance.get(api)
            .then((res: any) => {
                if (res.data.rss.channel && res.data.rss.channel.item) {
                    const comments: ArticleCommentData[] = res.data.rss.channel.item
                    const numOfDiscussions: number = res.data.rss.channel.sum_discussions;
                    const numOfComments: number = res.data.rss.channel.sum_talkbacks;
                    const hasMore: boolean = res.data.rss.channel.hasMore === 1;
                    this.setState((pState) => {
                        const newComments = uniqBy([...pState.comments, ...comments], 'id')
                        return {
                            comments: newComments,
                            numOfDiscussions,
                            numOfComments,
                            hasMore,
                        }
                    })
                }

                window.wcmNumOfComments = this.getTalkbackNumberView(this.state.numOfComments)

                if (!this.isWcmCommetnsRecived) {
                    const eventDetail: any = {
                        wcmNumOfComments: window.wcmNumOfComments
                    };

                    document.dispatchEvent(new CustomEvent('onWcmCommetnsRecived', {
                        detail: eventDetail
                    }));
                    this.isWcmCommetnsRecived = true;
                }
            })
    }







    private handleFormPopupClose = () => {
        this.setState({ isPopupOpen: false })
        document.querySelector("body").style.overflow = "auto";


    }
    private handleFormPopupOpen = () => {
        this.setState({ isPopupOpen: true })
        document.querySelector("body").style.overflow = "hidden";


    }
    private getTermsLinkByLang = () => {
        const { lang } = this.props
        if (lang === "he") return "https://www.ynet.co.il/article/bkswwa3sn";
        else if (lang === "ru") return "https://www.vesty.co.il/articles/0,7340,L-4867560,00.html";
        else return "https://www.ynetnews.com/article/bkh7s3p7t"
    }

    private openFormpoPup = () => {
        return null;
    }
    private loadMoreComments = (sortSelectionValue?: SortingOptions) => {
        const { page, sortSelection } = this.state;
        const nextPage = page + 1;
        this.setState({ page: nextPage }, () => {
            this.getCommentsData(sortSelectionValue ? sortSelectionValue : sortSelection, nextPage);
        });
        this.analyticsLoadMoreCommentsPushFunc()
    }

    private analyticsLoadMoreCommentsPushFunc = () => {
        if (typeof window !== "undefined") {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                event: 'comments_events',
                Category: 'Comments',
                Action: 'Watch More Comments'
            });
        }
    }


    render() {
        const { comments, IdOfLastTalkbackExpandedByUser, isAllCommentsPopupVisable } = this.state
        const { articleId, lang, displayType, isNewDesign } = this.props
        let EnglishSiteCss = lang === "en" ? "englishSite" : ""


        let AddCommentFormRender: AddCommentFormRender;
        let ArticleCommentRender: ArticleCommentRender;
        let ArticleCommentsTopTabRender: ArticleCommentsTopTabRender;

        if (displayType === "desktop") {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => <AddCommentFormUIGalhed props={props} />;
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentGalhedUi props={{ ...props }} isNewDesign={isNewDesign} />;
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => null;

        }
        else {
            AddCommentFormRender = (props: AddCommentFormRenderProps) => <MobileAddCommentFormUIGalhed props={{
                ...props,
                isPopUpOpened: this.state.isPopupOpen, soldierName: this.props.title, roof: this.props.roof,
                profileImageSrc: this.props.profileImageSrc,
                onClosePopUp: this.handleFormPopupClose,
                isNewDesign: this.props.isNewDesign
            }} />;
            ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentGalhedUi props={{ ...props }} isNewDesign={isNewDesign} />;
            ArticleCommentsTopTabRender = (props: ArticleCommentsTopTabRenderProps) => null;
        }


        const commentsToShow = comments;

        let term1 = " אין לשלוח תגובות הכוללות מידע המפר את";
        let term2 = "תנאי השימוש של Ynet";
        let term3 = " לרבות דברי הסתה, דיבה וסגנון החורג מהטעם הטוב.";
        if (lang === "en") {
            term1 = "The commenter agrees to the privacy policy of Ynet News and agrees not to submit comments that violate the ";
            term2 = "terms of use";
            term3 = ", including incitement, libel and expressions that exceed the accepted norms of freedom of speech.";
        }
        if (lang === "ru") {
            term1 = "Автор комментария принимает Условия конфиденциальности Вести и соглашается не публиковать комментарии, нарушающие ";
            term2 = "Правила использования";
            term3 = ",  в том числе подстрекательство, клевету и выходящее за рамки приемлемого в определении свободы слова.";
        }
        return (
            <div className={`${isNewDesign ? "GalhedSiteArticleCommentsRedesign" : "GalhedSiteArticleComments"} ${EnglishSiteCss}`} id="SiteArticleComments">
                <div className="commentsTopArea">
                    <div className="commentsTabHeader">
                        <div className="maintitle">{getTranslation(lang, "Each person is a world unto themselves")}</div>
                        <div className="subTitle"> {getTranslation(lang, "Add a personal dedication on the memorial wall")}</div>
                    </div>

                    {displayType === "mobile" && <div className="sendCommnetBtnWrapper">
                        {!isNewDesign && <div className="termsOfService">
                            {term1}
                            <a href={this.getTermsLinkByLang()} target="_blank" title={getTranslation(lang, "terms of use")} style={{ margin: "auto 5px" }} >{term2}</a>
                            {term3}
                        </div>}

                        <button className="sendBtn" id="addCommentSendButton" title={getTranslation(lang, "Send your dedication")} onClick={this.handleFormPopupOpen}>
                            <span>{getTranslation(lang, "Send your dedication")}</span>
                            {isNewDesign && <span className="arrow"></span>}
                        </button>
                    </div>}
                    <AddCommentFormWrapper
                        render={AddCommentFormRender}
                        isAddCommentFormVisible={true}
                        lang={lang}
                        articleId={articleId}
                        shouldTitleBeHidden={true}
                        formType={"NEW"}
                        handleCloseCommentForm={() => null}
                        isFirstComment={true}
                        isNewDesign={isNewDesign}
                    />



                </div>


                <div className="commentsContainer">
                    {isNewDesign && <div className="commentsTitle">{getTranslation(lang, "Your dedications")}</div>}
                    {commentsToShow.map((comment, i) =>
                        <div key={`comment_${comment.id}`}>
                            <ArticleCommentWrapper
                                render={ArticleCommentRender}
                                lang={lang}
                                IdOfLastTalkbackExpandedByUser={IdOfLastTalkbackExpandedByUser}
                                handleUpdateArticleCommentsStorageState={this.updateArticleCommentsStorageState}
                                isAutoExpanded={true}
                                articleId={articleId}
                                comment={comment}
                                handleCommentsPopupVisibility={() => null}
                                isFirma={true}
                                domain={undefined}
                                isFirmaMobileWeb={false}
                                handleCommentsPopupClose={() => null}
                                isAllCommentsPopupVisable={isAllCommentsPopupVisable}
                            />
                        </div>
                    )}
                </div>




            </div>
        )
    }
}
